
import { MdDeleteOutline } from "react-icons/md";
import { IoCloudDownloadOutline } from "react-icons/io5";
import "../styles.css";
import { useContentsContext } from "../hooks/useContentsContext";
import { useAuthContext } from "../hooks/useAuthContext";
import { useState } from "react";
import { saveAs } from 'file-saver';


const ImageDetails = ({ content }) => {
    const { dispatchcontent } = useContentsContext()
    const { user } = useAuthContext()
    const [, setError] = useState()

    const handleClick = async () => {

        const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/history/image/` + content.name, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${user}`
            }

        })
        const json = await response.json()

        if (!response.ok) {
            setError(json.error)
        }
        if (response.ok) {
            dispatchcontent({ type: 'DELETE_IMAGE_CONTENTS', payload: json })

        }
    }


    return (



        <div className="dark:bg-[#2e3247] dark:ring-0 dark:rounded-2xl  rounded ring-1 ring-slate-300 p-3 hover:shadow-xl ">

            <img Key={content.name} src={content.image ? content.image : null} alt="" />
            <div className="flex justify-between">

                <IoCloudDownloadOutline className="mt-3 cursor-pointer hover:text-black" size={24}  onClick={() =>{
                    saveAs(content.image ? content.image : null)
                }}/>
                <p className="mt-3">HD Image</p>
                <MdDeleteOutline className="mt-3 cursor-pointer hover:text-black" size={24} onClick={handleClick} />
            </div>
        </div>
    )

}

export default ImageDetails;